module.exports = __webpack_public_path__ + "static/img/60add.0db3259f.png";